import React from 'react';
import { motion } from 'framer-motion';
import { GaugeIcon, WavesIcon, SunMoonIcon } from 'lucide-react';
const principles = [{
  icon: GaugeIcon,
  title: 'Dopamine Regulation',
  description: "Reset your brain's reward system to find deep satisfaction in high-leverage work instead of cheap digital distractions."
}, {
  icon: WavesIcon,
  title: 'Cortisol Management',
  description: "Learn to modulate your stress response to eliminate the 'fog' that kills decision-making under pressure."
}, {
  icon: SunMoonIcon,
  title: 'Circadian Optimization',
  description: 'Align your hardest tasks with your natural biological peaks to achieve 2x output with half the effort.'
}];
export function TheScience() {
  return <section className="py-20 md:py-24 px-4 border-y border-white/5 bg-zinc-900/30" data-id="element-93" data-mp="17dxanfz0hy9q">
      <div className="max-w-5xl mx-auto" data-id="element-94" data-mp="17c437ygkra0o">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white text-center mb-12 md:mb-16 tracking-tight" data-id="element-95" data-mp="1cd9zu7dcvhfh">
          Built on Proven Biological Principles
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-96" data-mp="1n1yhcrkdst6h">
          {principles.map((principle, index) => <motion.div key={principle.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-zinc-950 border border-white/10 rounded-2xl p-8 text-center hover:border-green-500/30 transition-colors group" data-id="element-97" data-mp="1i46nhs06ewzn" data-mpi={index}>
              <div className="bg-green-500/10 w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-5 group-hover:bg-green-500/20 transition-colors" data-id="element-98" data-mp="254dyb3n20g7y">
                <principle.icon className="w-7 h-7 text-green-400" data-id="element-99" data-mp="2a1w2kgq4m79m" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-100" data-mp="2e4slk8jkw5e3">
                {principle.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-101" data-mp="1hdi11qztwstb">
                {principle.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}